import React from 'react';
import { UiCheckbox } from '../ui-kit';

/* eslint-disable react/prop-types */
export function UiCheckboxAdapter({ input, meta, ...rest }) {
  return (
    <UiCheckbox
      {...input}
      {...rest}
      errorMessage={meta.touched ? meta.error || meta.submitError || '' : ''}
    />
  );
}
